import { Observable } from 'rxjs';

import { InMessageFile } from '../shared';

/**
 * Tiny data structure that gives clients of the file-uploader
 * the name of the file beign uploaded,
 * the backend-assigned media id once available,
 * and an observable that emits percentage values
 */
export class UploadMonitor {
  file?: InMessageFile;

  uploadError = false;
  uploadComplete = false;

  constructor(
    public fileName: string,
    public progress: Observable<number>
  ) {
    // update error flag if the progress monitor reports an error
    progress.subscribe({
      error: () => (this.uploadError = true),
      complete: () => (this.uploadComplete = true),
    });
  }
}
